import { Box, Grid, makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import React from 'react';
import Top from '../../containers/topbutton/Top';
import { StyleProvider } from '../../contexts/StyleContext';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import Header from '../header/Header';
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";

const useStyles = makeStyles({
    jobCard: {
        borderRadius: 6,
        boxShadow: '0px 5px 35px rgba(80, 59, 59, 0.05), 0px 3px 6px #CCCCCC',
        padding: 30,
    },
    contentTitle: {
        fontSize: '2rem'
    },
    hi: {
        fontSize: '1.5rem'
    }
});


const AboutMe = () => {
    const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
    const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
    const classes = useStyles();
    const mobileDevice = useMediaQuery('(max-width:960px)');

    const changeTheme = () => {
        setIsDark(!isDark);
    };
    return (
        <div className={isDark ? "dark-mode" : null} style={{ minHeight: "100vh", paddingBottom: mobileDevice ? "16px" : "0", }}>
            <StyleProvider value={{ isDark: isDark, changeTheme: changeTheme }}>
                <Header outside />
                <Box style={{ maxWidth: "1200px", margin: "68px auto 0 auto", padding: "0 12px"}}>
                    <Grid container style={{ justifyContent: 'center' }} className={classes.jobCard}>
                        <Grid item md={6}>
                            <Box style={{ width: '100%' }}>
                                <img src="https://i.ibb.co/G4NCTtW9/About.jpg" alt="About me img" style={{ width: '100%', borderRadius: 6, height: "50vh", objectFit: "cover" }} />
                            </Box>
                        </Grid>
                        <Grid item md={6}>
                            <Box style={{ paddingLeft: !mobileDevice && 40, paddingTop: mobileDevice && 40 }} >
                                <Box style={{ marginBottom: 30 }}>
                                    <Typography className={classes.hi}>Hi, I am <span style={{ padding: 5, borderRadius: 6, backgroundColor: '#ff7731', color: '#fff', marginBottom: 10 }}>Mohammad Yasin</span> </Typography>
                                    <Typography className={classes.contentTitle}>A Web Developer</Typography>
                                    <Typography style={{ marginTop: 10, fontSize: !mobileDevice && 20 }}>
                                        I'm Yasin, a web developer with deep knowledge and proficiency in JavaScript, ReactJs, HTML, CSS, React Bootstrap, Material UI, and mobile responsive website development, as well as a strong ability to effectively design, efficient coding, and debug application codes.
                                        <br />
                                        <br />
                                        And with sound knowledge of NodeJs, ExpressJs, MongoDb, PHP, Laravel, MySQL.
                                        <br />
                                        <br />
                                        I love spending time on fixing little details and optimizing web apps.
                                        Also I like working in a team, you'll learn faster and much more. As the saying goes: 'Two heads are better than one'.
                                    </Typography>
                                </Box>
                                <Button
                                    text="See my resume"
                                    newTab={true}
                                    href={greeting.resumeLink}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    {/* <Grid container style={{ marginTop: 100 }}>
                        <Grid item style={{ padding: 8 }}>
                            <Box className={classes.jobCard}>
                                <Box>
                                    <Typography className={classes.contentTitle}>asdasd</Typography>
                                    <Typography>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.Feugiat enim a erat sit vulputate elementum orci.Risus nec viverra ornare venenatis proin ac varius tristique ut.Vitae egestas tellus amet nulla cursus.ands Pellentesque placerat maecenas egestas ullamcorper sed nunc.Vitae egestas tellus amet nulla something loss Pellentesque placerat maecenas egestas ullamcorper sed nunc.
                                        <br />
                                        <br />
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.Feugiat enim a erat sit vulputate elementum orci.Risus nec viverra ornare venenatis proin ac varius tristique ut.Vitae egestas tellus amet nulla cursus.ands Pellentesque placerat maecenas egestas ullamcorper sed nunc.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid> */}
                </Box>
                <Top />
            </StyleProvider >
        </div >

    );
};

export default AboutMe;
